import { client } from '../common/client';
import type { CreateWooCommerceOrderRequest, CreateWooCommerceOrderResponse } from './utils/types';

/**
 * API client for WooCommerce-related operations
 */
class WooCommerceAPIClient {
  /**
   * Create a new WooCommerce order
   * @param payload - Order creation request data
   * @returns Promise with created order data
   */
  public async createOrder(payload: CreateWooCommerceOrderRequest): Promise<CreateWooCommerceOrderResponse> {
    return await client.post('/woocommerce/orders', payload).then((res) => res.data);
  }
}

export const woocommerceAPIClient = new WooCommerceAPIClient();
